import { FunctionComponent, MouseEventHandler } from 'react';
import { Badge } from 'dibs-elements/exports/Badge';
import { Link } from 'dibs-elements/exports/Link';
import styles from './SharedRelatedBuyPages.scss';
import classnames from 'classnames';

import { BuySharedRelatedPages_buyPage } from '../../buy/BuySharedRelatedPages/__generated__/BuySharedRelatedPages_buyPage.graphql';

type Props = {
    relatedBuyPages: BuySharedRelatedPages_buyPage['relatedBuyPages'];
    onClick?: MouseEventHandler;
    isFullWidth?: boolean | null;
    dataTn?: string;
};

export const SharedRelatedBuyPages: FunctionComponent<Props> = ({
    relatedBuyPages,
    onClick = () => {},
    isFullWidth,
    dataTn,
}) => {
    const wrapperClasses = classnames(styles.wrapper, { [styles.fullWidthWrapper]: isFullWidth });
    const innerWrapperClasses = classnames(styles.innerWrapper, {
        [styles.fullWidthInnerWrapper]: isFullWidth,
    });

    return (
        relatedBuyPages && (
            <div className={wrapperClasses}>
                <div className={innerWrapperClasses}>
                    {relatedBuyPages.map(page => {
                        if (page && page.url && page.anchorText) {
                            return (
                                <Link
                                    key={page.url}
                                    href={page.url}
                                    onClick={onClick}
                                    dataTn={dataTn}
                                    className={`${styles.link} ${styles.specify}`}
                                >
                                    <Badge type="pill" size="medium-regular" interactive>
                                        {page.anchorText}
                                    </Badge>
                                </Link>
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            </div>
        )
    );
};
